import styles from "./styles.module.css";
import { MdDelete } from "react-icons/md";
import { useContext, useState } from "react";
import { TypesValue } from "../../../contexts/types";

export default function Field({ field, id, rename, handleDelete }) {
  const [editIsActive, setEditIsActive] = useState(false);
  const [name, setName] = useState(field.name);
  const context = useContext(TypesValue);

  const handleRename = (newName) => {
    rename(id, newName);
  };

  const type = (field) => {
    if (field.type.charAt(0) === "_" || field.type === "database") {
      for (let i = 0; i < context.length; i++) {
        if (context[i].name === field.type) {
          return context[i].displayName;
        }
      }
    }
    return field.type;
  };

  const handleChange = (e) => {
    setName(e.currentTarget.value);
  };

  const exitEditor = (e) => {
    if (e.key === "Enter" || e.key === "Tab") {
      handleRename(name);
      setEditIsActive(false);
    }
  };

  const handleBlur = () => {
    setName(field.name);
    toggleEdit();
  };

  const toggleEdit = () => {
    editIsActive ? setEditIsActive(false) : setEditIsActive(true);
  };

  const nameEditor = (
    <input
      autoFocus
      spellCheck={false}
      value={name}
      type={"text"}
      onChange={handleChange}
      onKeyPress={exitEditor}
      onBlur={handleBlur}
    />
  );

  if (field.editable || false) {
    return (
      <li>
        <div>
          <div onDoubleClick={toggleEdit} className={styles.fieldName}>
            {editIsActive ? nameEditor : <div>{name}</div>}
          </div>
          <p style={{ color: "#666" }}>{type(field)}</p>
          <p style={{ color: "#666" }}>{(field.list || false) ? "Yes" : "No"}</p>
          <div>
            <MdDelete className={styles.icon} onClick={() => handleDelete(id)} />
          </div>
        </div>
      </li>
    );
  }
  else {
    return (
      <li>
        <div>
          <div title="This field is not editable">{name}</div>
          <p style={{ color: "#666" }}>{type(field)}</p>
          <p style={{ color: "#666" }}>{(field.list || false) ? "Yes" : "No"}</p>
        </div>
      </li>
    );
  }
};
